<template>
  <div :class="$style.root">
    <el-card>
      <div slot="header">
        <span>缴费记录查询</span>
      </div>
      <el-row>
        <el-col :span="4">
          <div style="padding-right:40px;">
            <el-input v-model="criteria.match" placeholder="缴费单位"></el-input>
          </div>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="criteria.stime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择开始日期">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker
            v-model="criteria.etime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <div style="padding-left: 8px;">
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </div>
        </el-col>
      </el-row>
      <br>

      <el-table :data="list" border style="width: 100%" v-loading="loading">
        <el-table-column prop="stationcode" label="测点编码" width="100"></el-table-column>
        <el-table-column prop="stationname" label="测点名称" width="180"></el-table-column>
        <el-table-column prop="stime" label="开始时间" width="100">
          <template slot-scope="scope">
            {{scope.row.stime.split(' ')[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="etime" label="结束时间" width="100">
          <template slot-scope="scope">
            {{scope.row.etime.split(' ')[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="watercomsume" label="总用水量(顿)" width="100"></el-table-column>
        <el-table-column prop="money" label="总费用" width="100"></el-table-column>
        <el-table-column prop="payman" label="缴费人" width="100"></el-table-column>
        <el-table-column prop="payunit" label="缴费单位"></el-table-column>
        <el-table-column prop="accessman" label="收款人" width="200"></el-table-column>
        <el-table-column prop="accessunit" label="收款单位"></el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="showDetail(scope.$index, scope.row)">明细</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row>
        <el-col>
          <div style="float:right;margin:24px -10px 0 0;">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="search"
              :current-page.sync="pager.page"
              :page-size="pager.size"
              :page-count="pager.pages">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose">
      <div slot="title" v-if="list[selectedRow]">
        <span>{{list[selectedRow].stime.split(' ')[0]}} ~ {{list[selectedRow].etime.split(' ')[0]}} 明细数据</span>
      </div>
      <el-card>
        <payment-detail v-bind="list[selectedRow]" :list="detailList[selectedRow]"></payment-detail>
      </el-card>
    </el-dialog>

  </div>
</template>

<script>
import {
  stationquery,
  getallstationkind,
  payments
} from "@/apis/api"
import qs from 'qs'
import PaymentDetail from '../../components/payment-detail'

export default {
  name: 'payment-search',
  data() {
    return {
      loading: false,
      regioncode:null,
      userid:null,
      list: [],
      criteria: {
        match: null,
        // stime: '2014-01-01',
        // etime: '2019-02-01',
        stime: null,
        etime: null,
      },
      pager: this.getInitialPager(),

      selectedStationKind: null,
      stationKindList: [],
      stationList: [],

      dialogVisible: false,
      selectedRow: null
    }
  },
  computed: {
    stationListByType() {
      if(this.selectedStationKind) {
        return this.stationList.filter(item => item.StationType === this.selectedStationKind)
      } else {
        return this.stationList
      }
    },
    stationKeyByCode() {
      return this.stationList.reduce((map, obj) => {
        map[obj.FYCD] = obj
        return map
      }, {})
    },
    detailList() {
      return this.list.map(item => JSON.parse(item.detail))
    }
  },
  watch: {
    // 查询条件改变, 重置 pager
    criteria: {
      handler() {
        this.resetPager()
      },
      deep: true
    }
  },
  created() {
  	this.regioncode=sessionStorage.getItem('regioncode')
  	this.userid=JSON.parse(sessionStorage.getItem('userInfo')).uuid
    // this.fetchStationList()
    // this.fetchStationKindList()
//  console.log(this.regioncode,this.userid)
  },
  methods: {
    resetPager() {
      this.pager = this.getInitialPager()
    },
    getInitialPager() {
      return {
        page: 1,
        size: 12,
        pages: 1
      }
    },
    fetchStationList() {
       stationquery({regioncode:this.regioncode,userid:this.userid}).then(res => {
        this.stationList = res.result
      })
    },
    fetchStationKindList() {
      getallstationkind().then(res => {
        this.stationKindList = res.result
      })
    },
    fetchPaymentData() {
      this.loading = true
      payments(Object.assign({}, this.criteria, {
        page: this.pager.page,
        size: this.pager.size
      })).then(res => {
//      console.log(res)
        this.list = res.result.list
        this.loading = false
      })

      // mock -----
      // this.list = new Array(4).fill(0).map(
      //   (item, index) => ({
      //     stationcode:'10000' + index + this.pager.page,
      //     stationname:'测站名称' + index + this.pager.page,
      //     stime:'2016-09-07',
      //     etime:'2016-09-10',
      //     watercomsume: 10 + index + this.pager.page,
      //     paytime: '2019-09-10',
      //     payman: '缴费人' + index + this.pager.page,
      //     payunit: '缴费单位' + index + this.pager.page,
      //     accessman: '收款人' + index + this.pager.page,
      //     accessunit: '收款单位' + index + this.pager.page,
      //     money: 1000 + index + this.pager.page,
      //     detail: JSON.stringify(new Array(this.list.length).fill(0).map(
      //       (item, index) => {
      //         return new Array(20).fill(0).map(
      //           (item, index) => ({
      //             watercomsume: 440 + index * 10,
      //             price: 20 + index * 10,
      //             stime: '2019-09-10',
      //             etime: '2019-09-10',
      //           })
      //         )
      //       }
      //     ))
      //   })
      // )
      // this.pager.pages = 3
      // mock -----
    },
    search() {
      if(!this.criteria.stime || !this.criteria.etime) {
        this.$message({
          message: '请选择起止时间',
          type: 'warning'
        })
        return
      }
      this.fetchPaymentData()
    },
    showDetail(index) {
      this.dialogVisible = true
      this.selectedRow = index
    },
    handleClose(done) {
      this.selectedRow = null
      done()
    }
  },
  components: {
    PaymentDetail
  }
}
</script>

<style lang="less" module>
.root {
  padding: 1em;
}
.root, .root > :global(.el-card){
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/payment/history/search.vue